import { simpleSet } from '@r/reducers/utils';

const s = simpleSet as redux.reducers.initHappened;
export const initHappened = s( 'SET_INIT_HAPPENED', false );
